/**
 * Created by Rodrigo Quesada on 25/05/17.
 */
import {Injectable} from '@angular/core';
import {ToastyConfig, ToastyService} from 'ng2-toasty';

export interface Message {
    title: string;
    msg?: string;
    showClose?: boolean;
    theme?: string;
    timeout?: number;
    onAdd?: Function;
    onRemove?: Function;
}

const DEFAULT_MSG_TIMEOUT_SECS = 5;

@Injectable()
export class MessageService {

    constructor(private readonly _toastyService: ToastyService, private readonly _toastyConfig: ToastyConfig) {}

    success(title: string, message: string, timeoutSecs = DEFAULT_MSG_TIMEOUT_SECS) {
        this._toastyService.success({
            title: title,
            msg: message,
            showClose: true,
            timeout: timeoutSecs * 1000
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/messages/message.service.ts